import React from 'react';
import { Box, Typography, Paper, List, Divider } from '@mui/material';
import { BulletItem } from '../detail/ServiceContent';

// "Qué incluye" e "Info adicional" se guardan como texto, una cosa por renglón.
const lineas = (texto) => (typeof texto === 'string' ? texto.split('\n').map(l => l.trim()).filter(Boolean) : []);

// Descripción de la página, con el mismo diseño que "Sobre el servicio" del detalle de un servicio.
// Lo que la página no tiene no se inventa: sin descripción ni detalles no se muestra nada.
const PageAbout = ({ descripcion, incluye, infoAdicional }) => {
  const texto = typeof descripcion === 'string' ? descripcion.trim() : '';
  const queIncluye = lineas(incluye);
  const infoExtra = lineas(infoAdicional);

  const secciones = [];
  if (texto) {
    secciones.push(
      <Box key="descripcion">
        <Typography variant="subtitle2" fontWeight="bold" color="primary.main" gutterBottom>
          Descripción
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
          {texto}
        </Typography>
      </Box>
    );
  }
  if (queIncluye.length > 0) {
    secciones.push(
      <Box key="incluye">
        <Typography variant="subtitle2" fontWeight="bold" color="primary.main" gutterBottom>
          Qué incluye
        </Typography>
        <List sx={{ pt: 0, pb: 0 }}>
          {queIncluye.map((item, i) => <BulletItem key={i} text={item} />)}
        </List>
      </Box>
    );
  }
  if (infoExtra.length > 0) {
    secciones.push(
      <Box key="info">
        <Typography variant="subtitle2" fontWeight="bold" color="primary.main" gutterBottom>
          Info adicional
        </Typography>
        <List sx={{ pt: 0, pb: 0 }}>
          {infoExtra.map((item, i) => <BulletItem key={i} text={item} color="success.claro" />)}
        </List>
      </Box>
    );
  }

  if (secciones.length === 0) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight="bold" color="primary.main">
          Sobre la página
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Conoce más detalles
        </Typography>
      </Box>

      <Paper elevation={0} sx={{ p: { xs: 2.5, md: 3 }, borderRadius: '12px', border: 1, borderColor: 'sutil', backgroundColor: 'white' }}>
        {secciones.map((seccion, i) => (
          <React.Fragment key={seccion.key}>
            {i > 0 && <Divider sx={{ my: 3 }} />}
            {seccion}
          </React.Fragment>
        ))}
      </Paper>
    </Box>
  );
};

export default PageAbout;
